import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import React from 'react';
import {createRoot} from 'react-dom/client';
// Shared design system: tokens first, then component styles, then the admin's own CSS so it wins on conflicts.
import '@KristianIV/common-ui/theme.css';
import '@KristianIV/common-ui/common-ui.css';
import './index.css';
import App from './App';
import {applyStoredTheme} from './shell/theme';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import {compose, createStore} from "redux";
import reducers from "./reducers";
import {config} from "./firebaseUtil";

const composeEnhancer =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(reducers,   composeEnhancer());

firebase.initializeApp(config);
applyStoredTheme();

const fstore = firebase.firestore();
// // Disable deprecated features
// fstore.settings({
//     timestampsInSnapshots: true,
// });

export const db = fstore
    .collection("env")
    .doc("prod")
    .collection("app");

// Missing audio is part of the normal flow here; the real fix is the storage proxy
// answering 404 for missing files (so no decode is ever attempted). This handler is
// only console tidiness for decode errors that still slip through - it cannot
// suppress the dev overlay, whose listeners register before the app bundle runs.
window.addEventListener("unhandledrejection", (event) => {
    const reason: any = event.reason;
    if (reason && reason.name === "EncodingError") {
        console.warn("Audio not decodable (missing or invalid file in storage):", reason.message);
        event.preventDefault();
    }
});


// Other modules import `store` and `db` from this entry module, so it also loads where there is no page
// to mount into (jest). Only mount when the root element exists.
const rootElement = document.getElementById('root');
if (rootElement) {
    createRoot(rootElement).render(
        <Provider store={store}>
            <App/>
        </Provider>
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
